import { Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Text } from '@chakra-ui/react'
import React, { useRef } from 'react'
import submitFormFromOutside from '../../utils/submitFormFromOutside'
import ProposalForm from '../Forms/ProposalForm'
import { ModalProps } from './Modal.types'

const ProposalFormModal: React.FC<ModalProps> = ({ _id, isOpen = false, onClose }) => {
  const btnRef = useRef<any>()
  const formRef = useRef<HTMLFormElement>(null)

  const submitForm = () => {
    formRef.current && submitFormFromOutside(formRef.current)
  }

  return (
    <div>
      <Drawer
        size="md"
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            <Text fontSize="3xl">
              { _id ? 'Edit proposal' : 'New proposal'}
            </Text>
          </DrawerHeader>

          <DrawerBody>
            <ProposalForm _id={_id} onSuccess={onClose} formRef={formRef} />
          </DrawerBody>

          <DrawerFooter>
            <Button variant='outline' onClick={onClose} mr={3}>
              Cancel
            </Button>
            <Button onClick={submitForm} colorScheme='purple'>{ _id ? 'Update Proposal' : 'Create Proposal' }</Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </div>
  )
}

export default ProposalFormModal
